var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuspend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14109_43223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 4.66675V8.00008L9.33333 9.33341",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.334 14.6667L14.6673 12.6667L11.334 10.6667V14.6667Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.67759 13.9621C7.42284 14.1047 6.15508 13.8478 5.05485 13.2279C3.95462 12.6081 3.07803 11.6568 2.5499 10.5097C2.02177 9.36265 1.86904 8.07817 2.11346 6.83921C2.35788 5.60026 2.98698 4.47001 3.91117 3.60943C4.83537 2.74885 6.00753 2.2018 7.26074 2.04621C8.51395 1.89062 9.78431 2.1344 10.8909 2.74286C11.9975 3.35131 12.8839 4.2934 13.4238 5.43496C13.9638 6.57653 14.1298 7.85936 13.8983 9.10078",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14109_43223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuspend);
export default __webpack_public_path__ + "static/media/Suspend.1f513a5d93cfd2fd4a3e679bc6a99ab0.svg";
export { ForwardRef as ReactComponent };